import React from 'react';
import { SimpleModal } from '../modal';

const AuthFailed = (props) => {
  const { open, onOk, footer, tips, title } = props;
  return (
    <SimpleModal
      visible={open}
      modalText={title || '认证失败'}
      wrapperClassName="auth-failed-wrap"
      tips={tips}
      onOk={onOk}
      footer={footer}
    />
  );
}

export default AuthFailed;
